import {
    FETCH_PARTNER_PLANS_REQUEST,
    FETCH_PARTNER_PLANS_SUCCESS,
    FETCH_PARTNER_PLANS_FAILURE,

    CREATE_PARTNER_PLAN_REQUEST,
    CREATE_PARTNER_PLAN_SUCCESS,
    CREATE_PARTNER_PLAN_FAILURE,

    UPDATE_PARTNER_PLAN_REQUEST,
    UPDATE_PARTNER_PLAN_SUCCESS,
    UPDATE_PARTNER_PLAN_FAILURE,

    DELETE_PARTNER_PLAN_REQUEST,
    DELETE_PARTNER_PLAN_SUCCESS,
    DELETE_PARTNER_PLAN_FAILURE,
} from "../actions/types";

const initialState = {
    plans: [],
    loading: false,
    error: null,
    message: "",
};

const partnerPlanReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_PARTNER_PLANS_REQUEST:
        case CREATE_PARTNER_PLAN_REQUEST:
        case UPDATE_PARTNER_PLAN_REQUEST:
        case DELETE_PARTNER_PLAN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_PARTNER_PLANS_SUCCESS:
            return {
                ...state,
                loading: false,
                plans: action.payload || [],
            };

        case CREATE_PARTNER_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                plans: [
                    action.payload,
                    ...state.plans,
                ],
                message:
                    "Partner plan created successfully",
            };

        case UPDATE_PARTNER_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                plans: state.plans.map((plan) =>
                    plan.plan_id ===
                        action.payload.plan_id
                        ? action.payload
                        : plan
                ),
                message:
                    "Partner plan updated successfully",
            };

        case DELETE_PARTNER_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                plans: state.plans.filter(
                    (plan) =>
                        plan.plan_id !== action.payload
                ),
                message:
                    "Partner plan deleted successfully",
            };

        case FETCH_PARTNER_PLANS_FAILURE:
        case CREATE_PARTNER_PLAN_FAILURE:
        case UPDATE_PARTNER_PLAN_FAILURE:
        case DELETE_PARTNER_PLAN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default partnerPlanReducer;